export default __webpack_public_path__ + "static/media/gallery_09.68571df7.jpg";